// src/lib/demoMode.js
const DEMO_KEY = 'totono_demo_mode';
const DEMO_SIGNUP_KEY = 'totono_demo_signup';

export function isDemoMode() {
  return localStorage.getItem(DEMO_KEY) === '1';
}

export function enterDemoMode() {
  localStorage.setItem(DEMO_KEY, '1');
}

export function exitDemoMode() {
  localStorage.removeItem(DEMO_KEY);
  localStorage.removeItem(DEMO_SIGNUP_KEY);
}

// デモ中に保存・追加ボタンを押したとき→新規登録画面へ
export function redirectToSignup() {
  localStorage.setItem(DEMO_SIGNUP_KEY, '1'); // サインアップモードフラグ
  exitDemoMode();
  window.location.href = '/';
}

// Auth.js側で読み取ってsignupモードで開くために使う
export function shouldOpenSignup() {
  const val = localStorage.getItem(DEMO_SIGNUP_KEY) === '1';
  if (val) localStorage.removeItem(DEMO_SIGNUP_KEY);
  return val;
}
